import { useState, useEffect, useCallback } from "react";

const KEY = "ih_favs";
const read = () => {
  try { return JSON.parse(localStorage.getItem(KEY) || "[]"); } catch { return []; }
};

export const useFavorites = () => {
  const [favs, setFavs] = useState(read);

  useEffect(() => {
    const sync = () => setFavs(read());
    window.addEventListener("storage", sync);
    window.addEventListener("ih_favs", sync);
    return () => {
      window.removeEventListener("storage", sync);
      window.removeEventListener("ih_favs", sync);
    };
  }, []);

  const toggle = useCallback((id) => {
    const next = read().includes(id) ? read().filter((f) => f !== id) : [...read(), id];
    localStorage.setItem(KEY, JSON.stringify(next));
    window.dispatchEvent(new Event("ih_favs"));
    setFavs(next);
  }, []);

  const clear = useCallback(() => {
    localStorage.setItem(KEY, "[]");
    window.dispatchEvent(new Event("ih_favs"));
    setFavs([]);
  }, []);

  return { favs, toggle, clear };
};
